import { render } from "./Offline.vue?vue&type=template&id=07775c76"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Offline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07775c76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07775c76', __exports__)) {
    api.reload('07775c76', __exports__)
  }
  
  module.hot.accept("./Offline.vue?vue&type=template&id=07775c76", () => {
    api.rerender('07775c76', render)
  })

}


export default __exports__